import { ValidatorFn, AbstractControl } from '@angular/forms';
import { DateTimeUtility } from 'src/shared/utility/date-time.utility';

export function DateRangeValidator(
	fromControl: AbstractControl,
	toControl: AbstractControl
): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		return control.value === true &&
			(!DateTimeUtility.isValidDate(fromControl.value) ||
				!DateTimeUtility.isValidDate(toControl.value) ||
				!DateTimeUtility.isValidDateRange(
					fromControl.value,
					toControl.value
				))
			? { dateRange: { value: control.value } }
			: null;
	};
}
